module.exports = __webpack_public_path__ + "media/tulum/beach-2f9408e7.jpg";